module.exports = __webpack_public_path__ + "img/combo_chart_52px.888ddbe7.png";